import React, { Fragment } from "react";
import SectionBezel from "components/SectionBezel";
import DebounceTextarea from "components/DebounceTextarea";
import { getFieldPath } from "utils/form";
import { useFormikContext } from "formik";
import get from "lodash/get";
import { useFallbackRedirectUrls } from "utils/hooks";
import { STATE_KEYS } from "utils/constants/state";

const FOOTER = {
  DEFAULT:
    "This message will be shown on the default payment confirmation page after a successful checkout.",
  SUCCESS_URL_CONFLICT:
    "Reset the success URL redirect to it's default value in order to customize the checkout confirmation message."
};

const PLACEHOLDER = "Add an optional confirmation message here";

const ConfirmationFields = ({ name }) => {
  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();
  const { successUrl: defaultSuccessUrl } = useFallbackRedirectUrls();
  const copyPath = getFieldPath(name, "copy");
  const copyMessage = get(values, copyPath);

  const currentSuccess = get(values, STATE_KEYS.SHORT_LINK.SUCCESS_URL);
  const successIsDefault = currentSuccess.split("?")[0] === defaultSuccessUrl;

  const placeholder = successIsDefault ? PLACEHOLDER : "";
  let content;
  if (successIsDefault) {
    content = (
      <Fragment>
        <div className="pb3">
          <DebounceTextarea
            label="Message"
            name={copyPath}
            disabled={!successIsDefault}
            inputValue={copyMessage}
            placeholder={placeholder}
            debounce={500}
            valueSet={(val) => {
              setFieldValue(copyPath, val);
              if (!get(touched, copyPath)) {
                setFieldTouched(copyPath, true);
              }
            }}
          />
        </div>
        <div className="flex flex-column pt3 bt hairline-1">
          <div className="f6 lh-copy">{FOOTER.DEFAULT}</div>
          {/* Add an optional Link here to the docs */}
        </div>
      </Fragment>
    );
  } else {
    content = <div className="f6 lh-copy">{FOOTER.SUCCESS_URL_CONFLICT}</div>;
  }

  return (
    <SectionBezel header="Confirmation" expandable open={false}>
      {content}
    </SectionBezel>
  );
};

export default ConfirmationFields;
